<template>
  <v-container>
    <h1>{{ get("header-1") }}</h1>
    <parameter ref="param" @error="onError" @data="onData"></parameter>
  </v-container>  
</template>

<script>
import apiService from "@/_services/api-service";
import { Constants, Status } from "@/constants";
import localizationMixin from "@/mixins/localization-mixin";
import notificationMixin from "@/mixins/notification-mixin";
import paramCtrl from "@/components/controls/parameter";
import store from "@/store"

export default {
  name: 'account-verified',

  components: {
    "parameter": paramCtrl,
  },

    created() {
    this.pageName = "verified";
  },

  mixins: [notificationMixin, localizationMixin],

  mounted() {
    console.log('verified.mounted()');
    this.$refs.param.get(this.$route.params.id)
  },

  methods: {
    onCloseNotification(status) {
      console.log(status);
      
      this.$router.push('/vehicle/fillup/' + Constants.guid);
    },

    onData(data) {
      console.log("Data:", data);
      const x = JSON.parse(data.jsonData);
      x.isVerified = true,
      store.commit("setUser", x);
      store.commit("updateMenu");
      console.log("User", x);
      this.createNotification("User Verified", Status.success, ["Login Successful"], this.onCloseNotification);
      const url = "user?id=" + x.id;
      apiService.put(url, "", this.onUserSuccess, this.onUserError);
    },

    getLocalization(){},

    onUserSuccess() {
    },
    onUserError() {},

    registerUser(id) {
      const url = "user?id=" + id;
      apiService.put(url, "", this.onSuccess, this.onError);
    },

    onError(result){
      this.createNotification("Register User", Status.error, ["Failed to register user id", result])
    },

    onSuccess(result) {
      console.log("result:", result);
      this.createNotification("Register User", Status.success, ["New user registered"]);
    }
  }
}
</script>

<style>

</style>